import { Facility } from '../types/Facility';
import baseGoApi from "@/api/baseGoApi.ts";
const FACILITY_ENDPOINT = '/facility/';

export const getFacilitiesForOrganisation = async (): Promise<Facility[]> => {
    const response = await baseGoApi.get<Facility[]>(FACILITY_ENDPOINT+'organisation');
    return response.data;
};

export const getFacilities = async (): Promise<Facility[]> => {
    const response = await baseGoApi.get<Facility[]>(FACILITY_ENDPOINT);
    return response.data;
};

export const getFacility = async (id: number): Promise<Facility> => {
    const response = await baseGoApi.get<Facility>(`${FACILITY_ENDPOINT}${id}`);
    return response.data;
};

export const createFacility = async (facility: Partial<Facility>): Promise<Facility> => {
    const response = await baseGoApi.post<Facility>(FACILITY_ENDPOINT, facility);
    return response.data;
};

export const updateFacility = async (id: number, facility: Partial<Facility>): Promise<Facility> => {
    const response = await baseGoApi.put<Facility>(`${FACILITY_ENDPOINT}${id}`, facility);
    return response.data;
};

export const deleteFacility = async (id: number): Promise<void> => {
    await baseGoApi.delete(`${FACILITY_ENDPOINT}${id}`);
};
